import { Box, Button, Dialog, Theme, Typography } from '@mui/material';
import React, { useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';
import { resendOtp, validateOtp } from '../../../../redux-store/actions/cart';
import { ResendOtpResponseBody, ValidateOtpResponseBody } from '../../../../redux-store/types/cart';
import { showError } from '../../../../redux-store/actions/auth';
import OTPForm from '../../../../lib/formik/OtpForm';
import { SuccessIcon } from '../../../../assets/SvgIcons';

export default function CheckandVerifyOtp(): JSX.Element {
    const { url } = useRouteMatch();
    const history = useHistory();
    const { cartId, id, message, paymentId } = history.location.state as unknown as { paymentId: string, cartId: string, id: string, message: string };
    const [otpMessage, setOtpMessage] = useState<string>(message ?? '');
    const dispatch = useDispatch();
    const [paymentNotRequired, setPaymentNotRequired] = useState<boolean>(false);
    const [paymentFalseMessage, setPaymentFalseMessage] = useState<string>('');



    const handleSubmit = async (otp: string) => {
        const payload = {
            otp,
            token: paymentId ?? "",
            id,
            cartId: cartId ?? ""
        }

        const response = await (dispatch(validateOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>)
        if (response?.isSuccess) {
            setPaymentNotRequired(true);
            setPaymentFalseMessage(response?.message ?? "");
        }
        else {
            dispatch(showError(response?.message ?? ""));
        }
    }

    const handleResend = async () => {
        const payload = {
            cartId: cartId ?? "",
            id: id ? `${id}` : "",
            token: paymentId ?? ""
        }

        const response = await (dispatch(resendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            setOtpMessage(response?.message ?? "");
            history.replace({
                pathname: url,
                state: { id: response?.id ?? "", cartId: response?.cartId ?? "", message: response?.message ?? "", paymentId: response?.token ?? "" }
                //updating id in location:state if resend otp is success
            });
        }
    }

    const handlePaymentFalsePopup = () => {
        setPaymentNotRequired(false);
        history.replace('/investor-dashboard');
    }

    return (
        <>
            <Box sx={{ padding: '30px 45px' }}>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Transaction Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <Box sx={{ minWidth: { xs: "300px", sm: "350px" }, maxWidth: "500px" }}>
                        <OTPForm
                            onSubmit={handleSubmit}
                            onResend={handleResend}
                            otpMessage={otpMessage ?? ''}
                            warningMessage=""
                        />
                    </Box>
                </Box>
            </Box>
            <Dialog
                onClose={() => setPaymentNotRequired(false)}
                open={paymentNotRequired}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={handlePaymentFalsePopup}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
